/**
 * Hard-reload the current page.
 *
 * This exists as its own module purely so it can be intercepted. jsdom marks
 * `window.location` `[Unforgeable]`, so `vi.spyOn(window.location, 'reload')`
 * dies with "Cannot redefine property: reload" and there is no way for a spec to
 * observe the call in place. Behind a module boundary, `vi.mock()` can replace
 * it — which is what lets plugins/06.chunkErrorReload.client.ts be unit-tested
 * rather than only reasoned about.
 */
export function reloadPage(): void {
  window.location.reload()
}
